import { useCallback, useState } from "react";

const NO_SESSION_EXPANDED_IDS: readonly string[] = [];

/**
 * The columns the user expanded while empty, per view key. Kept in memory
 * only, so a reload or leaving the page drops them.
 */
export const useSessionExpandedColumns = () => {
    const [idsByViewKey, setIdsByViewKey] = useState<
        Readonly<Record<string, readonly string[]>>
    >({});

    const getSessionExpandedIds = useCallback(
        (viewKey: string) => idsByViewKey[viewKey] ?? NO_SESSION_EXPANDED_IDS,
        [idsByViewKey],
    );

    /** Replaces one view's ids, keeping the latest ids of every other view. */
    const setSessionExpandedIds = useCallback(
        (viewKey: string, ids: readonly string[]) =>
            setIdsByViewKey((latest) =>
                latest[viewKey] === ids
                    ? latest
                    : { ...latest, [viewKey]: ids },
            ),
        [],
    );

    return { getSessionExpandedIds, setSessionExpandedIds };
};
